import { getUserIdFromJid } from '@/shared/utils';
import { clearState } from '../../rootAccess';
import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const initialState = {
   presence: {},
   typing: {},
};

const presenceDataSlice = createSlice({
   name: 'presenceData',
   initialState,
   reducers: {
      resetPresenceData() {
         return initialState;
      },
      setPresenceData(state, action) {
         const { fromUserJid } = action.payload;
         const userId = getUserIdFromJid(fromUserJid);
         state.presence[userId] = action.payload;
      },
      setTypingData(state, action) {
         const { fromUserId, groupId } = action.payload;
         const key = groupId || fromUserId;
         state.typing[key] = action.payload;
      },
      removeTypingData(state, action) {
         const { fromUserId, groupId } = action.payload;
         const key = groupId || fromUserId;
         delete state.typing[key];
      },
   },
   extraReducers: builder => {
      builder.addCase(clearState, () => initialState);
   },
});

export const { resetPresenceData, setPresenceData, setTypingData, removeTypingData } = presenceDataSlice.actions;
export const { reducer: presenceDataReducer } = presenceDataSlice;

export const usePresenceData = userId => useSelector(state => state.presenceData.presence[userId]);
export const useTypingData = userId => useSelector(state => state.presenceData.typing[userId]);
